import { render, staticRenderFns } from "./ProductTypeDialog.vue?vue&type=template&id=6f904ee5&scoped=true"
import script from "./ProductTypeDialog.vue?vue&type=script&lang=js"
export * from "./ProductTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductTypeDialog.vue?vue&type=style&index=0&id=6f904ee5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f904ee5",
  null
  
)

export default component.exports